import 'arrive';

document.arrive('.vegaPriceTable--expanded', {existing: true}, function () {
    var tableResponsive = this.querySelector('.table-responsive');
    if (!tableResponsive) return;

    var stickyScroll = document.createElement('div');
    stickyScroll.className = 'sticky-scrollbar';
    var stickyInner = document.createElement('div');
    stickyInner.className = 'sticky-scrollbar__inner';
    stickyScroll.appendChild(stickyInner);
    tableResponsive.insertAdjacentElement('afterend', stickyScroll);

    function syncWidth() {
        stickyInner.style.width = tableResponsive.scrollWidth + 'px';
    }
    syncWidth();
    window.addEventListener('resize', syncWidth);

    var syncing = false;
    stickyScroll.addEventListener('scroll', function () {
        if (syncing) return;
        syncing = true;
        tableResponsive.scrollLeft = stickyScroll.scrollLeft;
        syncing = false;
    });
    tableResponsive.addEventListener('scroll', function () {
        if (syncing) return;
        syncing = true;
        stickyScroll.scrollLeft = tableResponsive.scrollLeft;
        syncing = false;
    });
});

document.arrive('.vegaPriceTable', {existing: true}, function () {
    var container      = this;
    var filterProvince = container.querySelector('#filter-province');
    var filterProduct  = container.querySelector('#filter-product');
    var filterSearch   = container.querySelector('#filter-search');
    var rows           = container.querySelectorAll('.price-table tbody tr');

    if (!filterProvince || !filterProduct || !filterSearch || !rows.length) return;

    function applyFilters() {
        var prov   = filterProvince.value;
        var prod   = filterProduct.value;
        var search = filterSearch.value.toLowerCase().trim();

        rows.forEach(function (row) {
            var matchProv   = !prov   || row.dataset.province === prov;
            var matchProd   = !prod   || row.dataset.products.split('|').indexOf(prod) !== -1;
            var matchSearch = !search || row.dataset.code.indexOf(search) !== -1 || row.dataset.name.indexOf(search) !== -1;
            row.style.display = (matchProv && matchProd && matchSearch) ? '' : 'none';
        });
    }

    filterProvince.addEventListener('change', applyFilters);
    filterProduct.addEventListener('change', applyFilters);
    filterSearch.addEventListener('input', applyFilters);
});

document.arrive('.vegaMonitoraggioTable', {existing: true}, function () {
    var tableResponsive = this.querySelector('.table-responsive');
    if (tableResponsive) {
        var stickyScroll = document.createElement('div');
        stickyScroll.className = 'sticky-scrollbar';
        var stickyInner = document.createElement('div');
        stickyInner.className = 'sticky-scrollbar__inner';
        stickyScroll.appendChild(stickyInner);
        tableResponsive.insertAdjacentElement('afterend', stickyScroll);

        function syncWidth() {
            stickyInner.style.width = tableResponsive.scrollWidth + 'px';
        }
        syncWidth();
        window.addEventListener('resize', syncWidth);

        var syncing = false;
        stickyScroll.addEventListener('scroll', function () {
            if (syncing) return;
            syncing = true;
            tableResponsive.scrollLeft = stickyScroll.scrollLeft;
            syncing = false;
        });
        tableResponsive.addEventListener('scroll', function () {
            if (syncing) return;
            syncing = true;
            stickyScroll.scrollLeft = tableResponsive.scrollLeft;
            syncing = false;
        });
    }

    var container    = this;
    var tableBody    = container.querySelector('.table-responsive');
    var theadScroll  = container.querySelector('.thead-scroll');

    // Sincronizza scroll orizzontale: body → thead
    if (tableBody && theadScroll) {
        tableBody.addEventListener('scroll', function () {
            theadScroll.scrollLeft = tableBody.scrollLeft;
        });
    }

    var filterProvince = container.querySelector('#monitoraggio-filter-province');
    var filterProduct  = container.querySelector('#monitoraggio-filter-product');
    var rows           = container.querySelectorAll('.price-table--body tbody tr');

    if (!filterProvince || !filterProduct || !rows.length) return;

    function applyFilters() {
        var prov = filterProvince.value;
        var prod = filterProduct.value;

        rows.forEach(function (row) {
            var matchProv = !prov || row.dataset.province === prov;
            var matchProd = !prod || row.dataset.product === prod;
            row.style.display = (matchProv && matchProd) ? '' : 'none';
        });
    }

    filterProvince.addEventListener('change', applyFilters);
    filterProduct.addEventListener('change', applyFilters);
});